import { Button, Modal } from "./components";
import { useTheme, THEMES } from "./theme";

export function ThemeSelect(props: { close: () => void }) {
  const [selected, setTheme] = useTheme();

  return (
    <Modal width="lg">
      <div className="text-text-secondary mb-5">choose your fighter</div>

      <div className="grid grid-cols-2 gap-x-2 gap-y-4 mb-7">
        {THEMES.map((theme) => (
          <div className="flex flex-col items-center justify-center">
            <div
              data-theme={theme}
              onClick={() => setTheme(theme)}
              className={`w-full py-2.5 rounded-md bg-bg inline-flex flex-col justify-start items-start gap-2 overflow-hidden border-2 ${
                theme === selected
                  ? "border-border-selected"
                  : "border-transparent"
              }`}
            >
              <div className="self-stretch p-2.5 bg-bg-surface inline-flex justify-start items-start gap-2 overflow-hidden">
                {Array.from({ length: 2 }).map((_, i) => (
                  <div
                    key={i}
                    className="flex-1 h-5 p-2.5 bg-bg-brand rounded-[5px]"
                  />
                ))}
              </div>
              <div className="self-stretch p-2.5 bg-bg-surface grid grid-cols-2 grid-rows-2 gap-2 overflow-hidden">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div
                    key={i}
                    className="h-8 relative bg-bg-brand-alt rounded"
                  />
                ))}
              </div>
            </div>
            <div className="text-text-secondary">{theme}</div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center">
        <Button
          onClick={() => {
            props.close();
          }}
        >
          let's go
        </Button>
      </div>
    </Modal>
  );
}
